<!-- src/views/MiniProgramVipRecharge.vue -->
<template>

  <div class="vip-page theme-starry">

    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="main-title">抖数君VIP充值</h1>
<!--      <p class="subtitle">小程序专属VIP套餐</p>-->
    </div>

    <!-- 修改后的用户ID输入框 -->
    <div class="user-id-input">
      <div style="display: flex; align-items: center;">
        <label style="margin-right: 10px; margin-bottom: 5px; font-weight: bold; font-size: 20px; color: #dc3545;">用户id:</label>
        <input
            v-model="userId"
            type="number"
            @input="handleInput"
            placeholder="请输入用户id"
            class="user-id-field"      style="flex: 1; min-width: 120px;"
        />
        <button
            class="paste-btn"
            @click="pasteUserId()"
            title="粘贴"
        >
          粘贴
          <Icon type="ios-paste" size="20" />
        </button>
        <button
            class="clearinput-btn"
            @click="clearInput()"
            title="清空"
        >
          清空
          <Icon type="ios-paste" size="20" />
        </button>
      </div>
    </div>

    <!-- 在粘贴按钮后面添加获取用户ID说明按钮 -->
<!--    <div style="align-items: center; margin-top: 1px;">
      <button
          class="help-btn"
          @click="showHelpModal = true"
          title="怎么获取用户id"
      >
        怎么获取用户id呢？
      </button>
    </div>-->

    <!-- 描述区域 -->
    <section class="vip-desc">
      <p class="sub-text">(支持查权重、查作品、和取素材)</p>
      <button
          class="help-btn"
          @click="showHelpModal = true"
          title="怎么获取用户id"
      >
        怎么获取用户id呢？
      </button>
    </section>

    <!-- 月低请求版 -->
    <h3 style="text-align: center">低请求版</h3>
    <p class="category-desc">每日限额 300 次</p>
    <div class="packages">
      <div
          v-for="pkg in packages.filter(p => p.type === 1)"
          :key="pkg.id"
          class="package-card"
          :class="{ active: selectedPackage && selectedPackage.id === pkg.id }"
          @click="selectPackage(pkg)"
      >
        <div class="card-title">{{ pkg.name }}</div>
        <div class="card-features">
          <div class="feature-item">
            {{ pkg.duration === 0 ? '永久会员' : `${pkg.duration}天/会员每天` }}
          </div>
          <div class="feature-item">每天{{ pkg.daily_limit }}次查权重</div>
          <div class="feature-item">每天{{ pkg.daily_limit }}次查播放指数</div>
          <div class="feature-item">无限次取素材</div>
        </div>
        <div class="price">¥{{ pkg.price }}</div>
      </div>
    </div>

    <!-- 月高请求版 -->
    <h3 style="text-align: center">高请求版</h3>
    <p class="category-desc">每日限额 450 次</p>
    <div class="packages">
      <div
          v-for="pkg in packages.filter(p => p.type === 2)"
          :key="pkg.id"
          class="package-card"
          :class="{ active: selectedPackage && selectedPackage.id === pkg.id }"
          @click="selectPackage(pkg)"
      >
        <div class="card-title">{{ pkg.name }}</div>
        <div class="card-features">
          <div class="feature-item">
            {{ pkg.duration === 0 ? '永久会员' : `${pkg.duration}天/会员每天` }}
          </div>
          <div class="feature-item">每天{{ pkg.daily_limit }}次查权重</div>
          <div class="feature-item">每天{{ pkg.daily_limit }}次查播放指数</div>
          <div class="feature-item">无限次取素材</div>
        </div>
        <div class="price">¥{{ pkg.price }}</div>
      </div>
    </div>

    <!-- 底部说明 -->
    <footer class="page-footer">
      <p class="notice">
        说明：套餐为虚拟物品，一经订购不予退款。如遇套餐订购、会员权益及产品使用问题，请咨询客服。
      </p>
      <p class="wechat">
        微信号：<span class="wechat-id">duochacha001</span>
        <button class="copy-btn" @click="copyWechatId()">点击复制</button>
      </p>
    </footer>

    <!-- 固定支付按钮 -->
    <div class="fixed-pay-bar" v-if="selectedPackage">
      <div class="pay-info">
        <span class="price-text">¥{{ selectedPackage.price }}</span>
        <button class="btn-pay" @click="goToPay()">支付</button>
      </div>
    </div>

    <!-- 支付确认Modal -->
    <Modal
        v-model="showPayModal"
        :loading="payModalLoading"
        title="支付确认"
        @on-ok="confirmPay"
        @on-cancel="cancelPay"
    >
      <div class="pay-modal-content">
        <p>您即将购买 <strong>{{ selectedPackage?.name || '' }}</strong> 套餐</p>
        <p>价格: <strong>￥{{ selectedPackage?.price || 0 }}</strong></p>

        <!-- 添加支付方式选择 -->
        <div class="payment-methods">
          <h4>选择支付方式</h4>
          <div class="payment-options">
            <div
                :class="['payment-option', { active: paymentType === 'wxpay' }]"
                @click="selectPaymentType('wxpay')"
            >
              <img :src="require('@/assets/images/wechat_logo.png')" alt="微信支付" class="payment-logo" />
              <span>微信支付</span>
            </div>
            <div
                :class="['payment-option', { active: paymentType === 'alipay' }]"
                @click="selectPaymentType('alipay')"
            >
              <img :src="require('@/assets/images/alipay_logo.png')" alt="支付宝" class="payment-logo" />
              <span>支付宝</span>
            </div>
          </div>
        </div>

        <Alert show-icon style="margin-top: 15px;" type="warning">
          确认支付后将跳转到支付页面，请确保账户余额充足 请在新窗口中完成支付
        </Alert>
      </div>
    </Modal>

    <!-- 支付结果Modal -->
    <Modal
        v-model="showResultModal"
        :footer-hide="true"
        :mask-closable="true"
        title="支付结果"
        width="360"
    >
      <div class="result-modal-content" style="text-align: center;">
        <!-- 成功图标 -->
        <Icon
            v-if="payResult === 'success'"
            size="50"          style="color: #19be6b;"
            type="ios-checkmark-circle"
        />
        <!-- 失败图标 -->
        <Icon
            v-else-if="payResult === 'fail'"
            size="50"          style="color: #ed4014;"
            type="ios-close-circle"
        />
        <!-- 提示信息 -->
        <p style="font-size: 16px; margin: 15px 0;">{{ resultMessage }}</p>

        <!-- 成功时的操作按钮 -->
        <Button
            v-if="payResult === 'success'"
            type="primary"
            @click="closeResultModal"
        >
          确定
        </Button>
        <!-- 失败时的操作按钮 -->
        <div v-else-if="payResult === 'fail'">
          <Button @click="retryPay">重新支付</Button>
          <Button style="margin-left: 10px;" type="primary" @click="closeResultModal">
            关闭
          </Button>
        </div>
      </div>
    </Modal>

    <!-- 获取用户ID说明模态框 - 微信小程序风格 -->
    <transition name="modal-fade">
      <div v-if="showHelpModal" class="wechat-modal-overlay" @click.self="showHelpModal = false">
        <div class="wechat-modal">
          <!-- 关闭按钮 -->
          <div class="modal-close" @click="showHelpModal = false">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#999" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
              
          <!-- 标题 -->
          <div class="modal-header">
            <h3 class="modal-title">如何获取用户ID</h3>
          </div>
              
          <!-- 内容 -->
          <div class="modal-body">
            <div class="step-list">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-text">打开微信小程序 <strong>抖数君</strong></div>
              </div>
              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-text">点击底部导航栏的 <strong>"我的"</strong></div>
              </div>
              <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-text">页面顶部显示的就是您的 <strong>用户ID</strong></div>
              </div>
            </div>
                
            <!-- 示意图 -->
            <div class="help-image-container">
              <img :src="require('@/assets/images/shilitu.png')" alt="获取用户ID示意图" class="help-image" />
              <p class="image-tip">如图所示位置</p>
            </div>
          </div>
              
          <!-- 底部按钮 -->
          <div class="modal-footer">
            <button class="modal-btn primary" @click="showHelpModal = false">我知道了</button>
          </div>
        </div>
      </div>
    </transition>
    
    <!-- Toast 提示组件 - 微信小程序风格 -->
    <transition name="toast-fade">
      <div v-if="toast.visible" class="wechat-toast" :class="toast.type">
        <div class="toast-icon">
          <svg v-if="toast.type === 'success'" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else-if="toast.type === 'error'" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/>
            <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/>
            <path d="M12 8V12M12 16H12.01" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="toast-message">{{ toast.message }}</div>
      </div>
    </transition>



  </div>
</template>

<script>
import apiClient from '@/api/index';
import QRCode from 'qrcode';

export default {
  name: 'VipRecharge',
  data() {
    return {
      deviceType: 'mobile', // 默认自动判断  移动端还是pc端
      paymentType: 'wxpay', // 默认支付方式为微信支付
      packages: [], // 套餐列表
      selectedPackage: null, // 当前选中的套餐
      userId: '', // 添加用户ID字段
      showHelpModal: false, // 控制帮助模态框显示
      
      // Toast 提示状态
      toast: {
        visible: false,
        message: '',
        type: 'success' // success, error, warning
      },


      // 支付相关状态
      showPayModal: false,
      showResultModal: false,
      payModalLoading: false,
      payResult: '',
      resultMessage: '',

      // 支付数据
      payUrl: '',
      orderId: '',///订单ID
      qrcodeUrl: ''
    };
  },
  // ：created 是 Vue 实例生命周期中的一个钩子函数，在实例创建完成后立即调用
  created() {
    this.detectDeviceType();
  },

  async mounted() {
    console.log('组件开始挂载...');
    // 监听token过期事件
    window.addEventListener('tokenExpired', this.handleTokenExpired);

    // 添加安全检查
    await this.$nextTick(() => {
      if (this.$refs.someRef && this.$refs.someRef.parentNode) {
        console.log(this.$refs.someRef.parentNode);
      } else {
        console.warn('Node not found or not mounted in the DOM.');
      }
    });

    // 先加载套餐数据
    await this.fetchPackages();
    
    // 数据加载完成后设置标题
    document.title = '抖数君VIP充值';
  },

  methods: {
    // Toast 提示方法 - 微信小程序风格
    showToast(message, type = 'success', duration = 2000) {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.visible = true;
      
      setTimeout(() => {
        this.toast.visible = false;
      }, duration);
    },
    
    // 添加设备类型检测方法
    detectDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|android/.test(userAgent)) {
        this.deviceType = 'mobile'; // 手机端
      } else {
        this.deviceType = 'pc'; // PC端
      }
    },
    // 添加选择支付方式的方法
    selectPaymentType(type) {
      this.paymentType = type;
    },
    //清空输入框
    clearInput() {
      this.userId = '';
    },

    handleInput(event) {
      // 确保值为数字格式
      this.userId = event.target.value.replace(/[^\d]/g, '');
    },
    // 添加粘贴用户ID的方法

    async pasteUserId() {
      try {
        // 优先使用 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          const text = await navigator.clipboard.readText();
          this.userId = text.trim();
          this.showToast('粘贴成功', 'success');
        } else {
          // 降级处理 - 使用 execCommand
          this.fallbackPasteText();
        }
      } catch (err) {
        console.error('粘贴失败:', err);
        // 出错时尝试降级方案
        this.fallbackPasteText();
      }
    },

// 降级粘贴方法
    fallbackPasteText() {
      try {
        const textArea = document.createElement("textarea");
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();

        const successful = document.execCommand('paste');
        if (successful) {
          // 给一点时间让粘贴完成
          setTimeout(() => {
            this.userId = textArea.value.trim();
            this.showToast('粘贴成功', 'success');
            document.body.removeChild(textArea);
          }, 100);
        } else {
          this.showToast('粘贴失败，请手动粘贴', 'error');
          document.body.removeChild(textArea);
        }
      } catch (err) {
        console.error('降级粘贴失败:', err);
        this.showToast('粘贴失败，请手动输入用户ID', 'error');
      }
    },
    /**
     * 获取所有套餐
     */
    async fetchPackages() {
      try {
        const response = await apiClient.get('mini_program/vip/packages');

        if (response.data && response.data.status === 'success') {
          this.packages = response.data.data;
        } else {
          this.showToast('获取套餐失败: ' + (response.data?.message || '未知错误'), 'error');
        }
      } catch (error) {
        this.showToast('请求错误: ' + error.message, 'error');
        console.error('请求错误:', error);
      }
    },

    /**
     * 选择套餐
     */
    selectPackage(pkg) {
      this.selectedPackage = pkg;
    },

    /**
     * 跳转到支付页面
     */
    goToPay() {
      // 验证用户ID是否已输入
      if (!this.userId) {
        this.showToast('请输入用户ID', 'error');
        //输入框获取焦点

        return;
      }

      if (!this.selectedPackage) {
        this.showToast('请选择套餐', 'warning');
        return;
      }

      // 显示支付确认模态框
      this.showPayModal = true;
    },

    /**
     * 确认支付
     */
    async confirmPay() {
      try {
        this.payModalLoading = true;

      /*  // 获取用户信息
        const userId = localStorage.getItem('userid') || '';

        // 验证必要参数
        if (!userId) {
          this.$Message.error('用户信息不完整，请重新登录');
          return;
        }
*/

        // 验证用户ID是否已输入
        if (!this.userId) {
          //this.$Message.error('请输入用户ID');
          console.log('请输入用户ID')
          this.showToast('请输入用户ID', 'error');
          return;
        }

        // 创建订单
        const response = await apiClient.post('mini_program/vip/create-order', {
          user_id: this.userId,
          package_id: this.selectedPackage.id,
          type: this.paymentType, // 添加支付类型参数
          device_type: this.deviceType === 'mobile' ? 'pc' : 'jump' // 添加设备类型参数
        });

        if (response.data.status === 'success') {
          // 获取支付信息
          const payInfo = response.data.data.pay_info;
          this.orderId = response.data.data.order_no;
          this.payUrl = response.data.data.pay_info.pay_url;
          //alert(response.data.data);
          this.qrcodeUrl = response.data.data.pay_info.qrcode_url;
          // alert(this.payUrl);
          // alert(this.qrcodeUrl);

          if (!payInfo) {
            this.showToast('支付信息错误', 'error');
            return;
          }


          // 在 confirmPay 方法中使用
          if (this.isWechatBrowser()) {

            // alert(this.qrcodeUrl);
            // alert('微信浏览器中直接跳转');

            // 微信浏览器中直接跳转
            window.location.href = this.qrcodeUrl;
            if (this.qrcodeUrl ===undefined){
              this.showToast(response.data.message || '创建订单失败', 'error');
              return;
            }

          } else {
            // 检测是否为手机端
            if (this.deviceType === 'mobile') {
              //alert('手机端');
             //先判断下是否是支付宝类型
              if (this.paymentType === 'alipay') {
                // 构造 alipays:// 跳转链接
                const alipayScheme = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent( this.qrcodeUrl)}`;
                // 跳转到支付宝 App
                window.location.href = alipayScheme;
                return
              }
              if (this.paymentType === 'wxpay'){
               /* alert('微信支付');
                alert(this.qrcodeUrl);*/
                // 微信支付逻辑
                const wechatScheme = this.qrcodeUrl; // 后端返回的 weixin:// 链接
                if (!wechatScheme) {
                  this.showToast('微信支付链接无效，请重新创建订单', 'error');
                  return;
                }
                this.showQRCodeModal(wechatScheme, 'wxpay'); // 传递 paymentMethod 参数
                return
              }
            }
           // alert('电脑端');
            // 电脑端使用新窗口打开
            window.open(this.payUrl, '_blank');
          }
          // 启动支付状态轮询
          this.startPolling();


        } else {
          this.showToast(response.data.message || '创建订单失败', 'error');
        }
      } catch (error) {
        this.showToast('网络错误: ' + error.message, 'error');
        console.error('请求错误:', error);
      } finally {
        this.payModalLoading = false;
        this.showPayModal = false;
      }
    },

    showQRCodeModal(qrCodeImageUrl, paymentMethod) {
      let title = '';
      let logoSrc = '';

      // 根据支付方式设置标题和 Logo
      if (paymentMethod === 'alipay') {
        title = '支付宝支付';
        logoSrc = require('@/assets/images/alipay_logo.png');
      } else if (paymentMethod === 'wxpay') {
        title = '微信支付';
        logoSrc = require('@/assets/images/wechat_logo.png');
      }

      // 确保支付链接有效
      if (!qrCodeImageUrl) {
        this.showToast('支付链接无效，无法生成二维码', 'error');
        return;
      }

      // 使用 QRCode.toDataURL 生成二维码图片
      QRCode.toDataURL(qrCodeImageUrl)
          .then((qrCodeBase64) => {
            console.log('Generated QR Code Base64:', qrCodeBase64);

            // 显示模态框
            this.$Modal.info({
              title: '',
              content: `            <div style="text-align: center; padding: 20px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); border: 1px solid #ddd;">
              <!-- 顶部绿色标题栏 -->
              <div style="background-color: #e8f5e8; color: #388e3c; padding: 10px; border-radius: 8px; margin-bottom: 8px;">
                <img src="${logoSrc}" alt="${title}Logo" style="width: 24px; margin-right: 8px; vertical-align: middle;" />
                <span style="font-size: 16px; font-weight: bold;">${title}</span>
              </div>

              <!-- 金额显示 -->
              <div style="color: #388e3c; font-size: 20px; margin-bottom: 4px;">
                ¥${this.selectedPackage?.price}              </div>

              <!-- 二维码图片 -->
              <img id="qrCodeImage" src="${qrCodeBase64}" alt="${title}二维码" style="width: 250px; height: 250px; margin-bottom: 8px;" />

              <!-- 系统订单号 -->
              <div style="background-color: #2d2d2d; color: white; padding: 10px; border-radius: 8px; margin-top: 8px;">
                <p style="margin: 0; font-size: 14px;">系统订单号：${this.orderId}</p>
                <p style="margin: 0; font-size: 14px;">请使用${paymentMethod === 'alipay' ? '支付宝' : '微信'}扫一扫</p>
                <p style="margin: 0; font-size: 14px;">扫描二维码支付</p>
              </div>
            </div>
          `,
              okText: '关闭',
            });
          })
          .catch((err) => {
            console.error('二维码生成失败:', err);
            this.showToast('二维码生成失败，请稍后重试', 'error');
          });
    },
    // 保存二维码到相册
    saveQrCode(qrCodeBase64) {
      const link = document.createElement('a'); // 创建一个 <a> 元素
      link.href = qrCodeBase64; // 设置下载链接为二维码图片的 Base64 URL
      link.download = `qrcode_${this.orderId}.png`; // 设置下载文件名
      link.click(); // 模拟点击下载

      // 提示用户保存成功
      this.showToast('二维码已保存到相册', 'success');
    },

// 检测是否为微信浏览器
    isWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('micromessenger');
    },

    /**
     * 启动支付状态轮询
     */
    startPolling() {
      const poll = async () => {
        try {
          // 调用后端查询订单状态接口
          const response = await apiClient.get('mini_program/vip/return-url', {
            params: {
              out_trade_no: this.orderId
            }
          });

          if (response.data.status === 'success') {
            const orderData = response.data.data;

            if (orderData.status === 'paid') {
              this.handlePaymentSuccess();
              return true;
            } else if (orderData.status === 'unpaid') {
              console.log('订单未支付');
              return false;
            } else {
              this.handlePaymentFail();
              return true;
            }
          } else {
            console.error('查询订单状态失败:', response.data.message);
            return false;
          }
        } catch (error) {
          console.error('支付状态轮询失败:', error);
          return false;
        }
      };

      // 每5秒轮询一次，最多轮询20次
      let attempts = 0;
      const maxAttempts = 20;
      const interval = setInterval(async () => {
        attempts++;
        const finished = await poll();

        if (finished || attempts >= maxAttempts) {
          clearInterval(interval);
          if (!finished && attempts >= maxAttempts) {
            this.showToast('支付超时，请检查支付状态', 'warning');
          }
        }
      }, 5000);
    },

    /**
     * 处理支付成功
     */
    handlePaymentSuccess() {
      this.payResult = 'success';
      this.resultMessage = 'VIP套餐购买成功！您的VIP权限已更新。请重新打开抖数君小程序，退出账号重新登录。即可看到新的VIP权限。';
      this.showToast(this.resultMessage, 'success', 3000);
      this.showResultModal = true;
    },

    /**
     * 处理支付失败
     */
    handlePaymentFail() {
      this.payResult = 'fail';
      this.resultMessage = '支付失败，请重试。';
      this.showToast(this.resultMessage, 'error');
      this.showResultModal = true;
    },

    /**
     * 取消支付
     */
    cancelPay() {
      this.showPayModal = false;
      this.payModalLoading = false;
    },

    /**
     * 关闭结果模态框
     */
    closeResultModal() {
      this.payResult = '';
      this.resultMessage = '';
      this.showResultModal = false;
    },

    /**
     * 重新支付
     */
    retryPay() {
      this.showResultModal = false;
      this.showPayModal = true;
    },

    /**
     * 复制微信ID
     */
    copyWechatId() {
      const wechatId = "duochacha001";

      // 检查浏览器是否支持 clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(wechatId).then(() => {
          this.showToast('复制成功', 'success');
        }).catch(() => {
          this.showToast('复制失败', 'error');
          // 降级处理
          this.fallbackCopyTextToClipboard(wechatId);
        });
      } else {
        // 使用降级处理
        this.fallbackCopyTextToClipboard(wechatId);
      }
    },

    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.showToast('复制成功', 'success');
        } else {
          this.showToast('复制失败', 'error');
        }
      } catch (err) {
        this.showToast('复制失败', 'error');
      }

      document.body.removeChild(textArea);
    }



  }
};
</script>

<style scoped>

/* 添加支付方式相关样式 */
/* 支付方式容器样式 */
.payment-methods {
  margin: 20px 0; /* 上下外边距20px，左右0 */
}

/* 支付方式标题样式 */
.payment-methods h4 {
  margin-bottom: 10px; /* 底部外边距10px */
  font-weight: bold; /* 字体加粗 */
}

/* 支付选项容器，使用弹性布局 */
.payment-options {
  display: flex; /* 弹性布局 */
  justify-content: space-around; /* 主轴内容环绕分布 */
}

/* 单个支付选项样式 */
.payment-option {
  display: flex; /* 弹性布局 */
  flex-direction: column; /* 垂直排列子元素 */
  align-items: center; /* 交叉轴居中对齐 */
  padding: 10px; /* 内边距10px */
  border: 1px solid #eaeaea; /* 1px浅灰色边框 */
  border-radius: 8px; /* 8px圆角 */
  cursor: pointer; /* 鼠标指针为手型 */
  transition: all 0.3s ease; /* 所有属性变化0.3秒缓动过渡 */
}

/* 支付选项悬停状态 */
.payment-option:hover {
  border-color: #f53c8a; /* 边框颜色改为粉红色 */
}

/* 选中的支付选项样式 */
.payment-option.active {
  border-color: #f53c8a; /* 边框颜色为粉红色 */
  background-color: #fff5f8; /* 背景颜色为浅粉色 */
}

/* 支付logo图片样式 */
.payment-logo {
  width: 40px; /* 宽度40px */
  height: 40px; /* 高度40px */
  margin-bottom: 5px; /* 底部外边距5px */
}

/* 帮助按钮样式 */
.help-btn {
  padding: 8px 12px; /* 内边距上下8px，左右12px */
  background: #17a2b8; /* 背景颜色蓝绿色 */
  color: white; /* 文字颜色白色 */
  border: none; /* 无边框 */
  border-radius: 4px; /* 4px圆角 */
  cursor: pointer; /* 鼠标指针为手型 */
  font-size: 12px; /* 字体大小12px */
  transition: all 0.3s ease; /* 所有属性变化0.3秒缓动过渡 */
}

/* 帮助按钮悬停状态 */
.help-btn:hover {
  background: #138496; /* 背景颜色深蓝绿色 */
  transform: translateY(-1px); /* 向上移动1px */
}

/* 帮助按钮按下状态 */
.help-btn:active {
  transform: translateY(0); /* 回到原位置 */
}

/* 帮助模态框内容样式 */
.help-modal-content {
  text-align: left; /* 文本左对齐 */
  line-height: 1.6; /* 行高1.6倍 */
}

/* 帮助模态框段落样式 */
.help-modal-content p {
  margin-bottom: 8px; /* 底部外边距8px */
}

/* 帮助图片容器样式 */
.help-image-container {
  text-align: center; /* 文本居中 */
  margin-top: 15px; /* 顶部外边距15px */
}

/* 帮助图片样式 */
.help-image {
  max-width: 100%; /* 最大宽度100% */
  border-radius: 8px; /* 8px圆角 */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1); /* 阴影效果 */
}

/* 会员页面整体样式 */
.vip-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; /* 字体族：苹方、微软雅黑、无衬线字体 */
  background-color: #f8f9fa; /* 页面背景色：浅灰色 */
  color: #333; /* 全局文字颜色：深灰色 */
  padding: 20px; /* 页面内边距：上下左右各20px */
  padding-bottom: 120px; /* 为固定支付栏留出足够空间 */
}

/* 页面头部样式 */
.page-header {
  text-align: center; /* 头部文字水平居中 */
  margin-bottom: 20px; /* 头部底部外边距：20px（与下方内容分隔） */
}

/* 页面头部标题样式 */
.page-header h1 {
  font-size: 24px; /* 标题字号：24px */
  color: #2c3e50; /* 标题颜色：深青灰色 */
}

/* 会员说明区域样式 */
.vip-desc {
  text-align: center; /* 说明文字水平居中 */
  margin-bottom: 30px; /* 说明区域底部外边距：30px（与下方套餐分隔） */
}

/* 说明区域子文本样式 */
.vip-desc .sub-text {
  font-size: 14px; /* 子文本字号：14px */
  color: #666; /* 子文本颜色：中灰色 */
  margin-top: 5px; /* 子文本顶部外边距：5px（与上方内容分隔） */
}

/* 套餐分类容器样式 */
.package-category {
  background: white; /* 分类容器背景色：白色 */
  border-radius: 12px; /* 容器圆角：12px（圆角效果） */
  padding: 20px; /* 容器内边距：20px */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05); /* 容器阴影：轻微灰色阴影，增强层次感 */
  margin-bottom: 30px; /* 分类容器底部外边距：30px（与下一个分类分隔） */
}

/* 套餐分类标题样式 */
.package-category h3 {
  font-size: 18px; /* 分类标题字号：18px */
  margin: 0 0 10px 0; /* 标题外边距：上下0，下10px，左0（与下方内容分隔） */
  color: #2c3e50; /* 分类标题颜色：深青灰色 */
}

/* 分类描述文本样式 */
.category-desc {
  font-size: 14px; /* 描述文本字号：14px */
  color: #777; /* 描述文本颜色：浅灰色 */
  margin-bottom: 15px; /* 描述文本底部外边距：15px（与下方套餐卡片分隔） */
  text-align: center; /* 描述文本水平居中 */
}

/* 套餐卡片容器样式（使用网格布局） */
.packages {
  display: grid; /* 启用网格布局 */
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* 列布局：自动适配数量，每列最小宽度100px，剩余空间平均分配 */
  gap: 15px; /* 网格项间距：15px（卡片之间的距离） */
  justify-content: center; /* 网格内容水平居中（当总宽度小于容器时） */
  max-width: 99%; /* 最大宽度：99%（避免过宽） */
  margin: 0 auto; /* 容器水平居中 */
}

/** 套餐卡片样式 */
.package-card {
  border: 1px solid #eaeaea; /* 卡片边框：1px浅灰色实线 */
  border-radius: 8px; /* 卡片圆角：8px */
  padding: 12px; /* 卡片内边距：12px */
  text-align: center; /* 卡片内容水平居中 */
  background: white; /* 卡片背景色：白色 */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); /* 卡片阴影：轻微阴影 */
  cursor: pointer; /* 鼠标悬停时指针变为手型（提示可点击） */
  transition: all 0.3s ease; /* 过渡动画：所有样式变化在0.3s内完成，缓动效果 */
  min-width: 100px; /* 卡片最小宽度：100px */
}

/* 选中的套餐卡片样式 */
.package-card.active {
  border-color: #f53c8a; /* 边框颜色：粉红色 */
  box-shadow: 0 4px 12px rgba(245, 60, 138, 0.3); /* 阴影：粉红色透明度30% */
  background-color: #fff5f8; /* 背景颜色：浅粉色 */
}

/* 套餐卡片 hover 状态样式（鼠标悬停时） */
.package-card:hover {
  transform: scale(1.05); /* 卡片缩放：放大1.05倍（增强交互感） */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 阴影增强：更深的阴影，突出卡片 */
  background-color: rgba(230, 230, 230, 0.1); /* 背景色：浅灰色半透明（轻微变色反馈） */
}

/* 卡片标题样式 */
.card-title {
  font-size: 14px; /* 标题字号：14px */
  font-weight: bold; /* 标题加粗 */
  margin-bottom: 6px; /* 标题底部外边距：6px（与下方内容分隔） */
  color: #e6223f; /* 标题颜色：橙色 */
  overflow: hidden; /* 隐藏溢出内容（配合换行避免超出容器） */
  white-space: normal; /* 允许文字自动换行（默认值，若被覆盖需显式设置） */
  overflow-wrap: break-word; /* 强制长单词/文本换行（避免长内容溢出） */
  /* text-overflow: ellipsis; 注释：省略号与换行冲突，故禁用 */
}

/* 卡片功能列表样式 */
.card-features {
  font-size: 12px; /* 功能文本字号：12px */
  color: #555; /* 功能文本颜色：中深灰色 */
  line-height: 1.5; /* 行高：1.5倍（增强可读性） */
  margin-bottom: 10px; /* 功能列表底部外边距：10px（与价格区域分隔） */
}

/* 单个功能项样式 */
.feature-item {
  margin: 4px 0; /* 功能项上下外边距：4px（项之间的间距） */
}

/* 价格文本样式 */
.price {
  font-size: 16px; /* 价格字号：16px */
  font-weight: bold; /* 价格加粗（突出显示） */
  color: #e67e22; /* 价格颜色：橙色（与标题呼应） */
  margin-top: 8px; /* 价格顶部外边距：8px（与上方功能列表分隔） */
}

/* 固定在底部的支付栏样式 */
.fixed-pay-bar {
  position: fixed; /* 定位方式：固定定位（不随页面滚动） */
  bottom: 0; /* 距离底部：0（贴底显示） */
  left: 0; /* 距离左侧：0（贴左） */
  right: 0; /* 距离右侧：0（贴右） */
  background: #2c3e50; /* 支付栏背景色：深青灰色 */
  color: white; /* 支付栏文字颜色：白色 */
  padding: 15px; /* 支付栏内边距：15px */
  display: flex; /* 启用弹性布局 */
  justify-content: space-between; /* 子元素两端对齐（左右分开） */
  align-items: center; /* 子元素垂直居中 */
  z-index: 100; /* 层级：100（确保在其他内容上方） */
}

/* 支付信息容器样式 */
.pay-info {
  display: flex; /* 启用弹性布局 */
  align-items: center; /* 子元素垂直居中 */
  gap: 15px; /* 子元素间距：15px */
}

/* 价格文本样式（支付栏内） */
.price-text {
  font-size: 20px; /* 价格字号：20px（突出显示） */
  font-weight: bold; /* 价格加粗 */
}

/* 支付按钮样式 */
.btn-pay {
  padding: 10px 20px; /* 按钮内边距：上下10px，左右20px */
  background: #f53c8a; /* 按钮背景色：粉红色 */
  color: white; /* 按钮文字颜色：白色 */
  border: none; /* 去除按钮边框 */
  border-radius: 20px; /* 按钮圆角：20px（椭圆形按钮） */
  font-size: 16px; /* 按钮文字字号：16px */
  cursor: pointer; /* 鼠标悬停时指针变为手型 */
}

/* 支付按钮 hover 状态样式（鼠标悬停时） */
.btn-pay:hover {
  background: #d32f80; /* 按钮背景色：深粉红色（加深颜色反馈） */
}

/* 页脚样式 */
.page-footer {
  margin-top: 20px; /* 页脚顶部外边距：20px（与上方内容分隔） */
  text-align: center; /* 页脚文字水平居中 */
  font-size: 14px; /* 页脚文字字号：14px */
  color: #666; /* 页脚文字颜色：中灰色 */
}

/* 通知文本样式 */
.notice {
  margin-bottom: 15px; /* 通知文本底部外边距：15px（与下方内容分隔） */
}

/* 微信信息容器样式 */
.wechat {
  display: flex; /* 启用弹性布局 */
  justify-content: center; /* 子元素水平居中 */
  align-items: center; /* 子元素垂直居中 */
  gap: 10px; /* 子元素间距：10px */
  margin-top: 10px; /* 容器顶部外边距：10px（与上方内容分隔） */
}

/* 微信ID文本样式 */
.wechat-id {
  font-weight: bold; /* 微信ID加粗（突出显示） */
  color: #2c3e50; /* 微信ID颜色：深青灰色 */
}

/* 复制按钮样式 */
.copy-btn {
  padding: 6px 12px; /* 按钮内边距：上下6px，左右12px */
  background: #e67e22; /* 按钮背景色：橙色（与标题/价格呼应） */
  color: white; /* 按钮文字颜色：白色 */
  border: none; /* 去除按钮边框 */
  border-radius: 4px; /* 按钮圆角：4px */
  font-size: 12px; /* 按钮文字字号：12px */
  cursor: pointer; /* 鼠标悬停时指针变为手型 */
}

/* 复制按钮 hover 状态样式（鼠标悬停时） */
.copy-btn:hover {
  background: #d35400; /* 按钮背景色：深橙色（加深颜色反馈） */
}

/* 用户ID输入框样式 */
.user-id-input {
  margin-bottom: 20px; /* 底部外边距20px */
  text-align: left; /* 改为左对齐 */
}

/* 用户ID标签样式 */
.user-id-input label {
  display: inline-block; /* 行内块元素 */
  margin-right: 10px; /* 右侧外边距10px */
  margin-bottom: 1px; /* 底部外边距1px */
  font-weight: bold; /* 字体加粗 */
  color: #333; /* 文字颜色深灰色 */
  font-size: 14px; /* 字体大小14px */
}

/* 用户ID字段容器样式 */
.user-id-field-container {
  display: flex; /* 弹性布局 */
  align-items: center; /* 交叉轴居中 */
  justify-content: center; /* 主轴居中 */
  width: 100%; /* 宽度100% */
  max-width: 360px; /* 最大宽度360px */
  margin: 0 auto; /* 水平居中 */
}

/* 用户ID输入框样式 */
.user-id-field {
  flex: 1; /* 弹性系数1 */
  padding: 12px 16px; /* 内边距上下12px，左右16px */
  border: 2px solid #eaeaea; /* 2px浅灰色边框 */
  border-radius: 8px 0 0 8px; /* 左上和左下圆角8px，右上和右下0 */
  font-size: 14px; /* 字体大小14px */
  outline: none; /* 无轮廓 */
  transition: all 0.3s ease; /* 所有属性变化0.3秒缓动过渡 */
}

/* 用户ID输入框聚焦状态 */
.user-id-field:focus {
  border-color: #f53c8a; /* 边框颜色粉红色 */
  box-shadow: 0 0 0 3px rgba(245, 54, 138, 0.1); /* 粉红色阴影效果 */
}

/* 粘贴按钮样式 */
.paste-btn {
  padding: 12px 16px; /* 内边距上下12px，左右16px */
  background: #f53c8a; /* 背景颜色粉红色 */
  color: white; /* 文字颜色白色 */
  border: none; /* 无边框 */
  border-radius: 0 8px 8px 0; /* 右上和右下圆角8px，左上和左下0 */
  cursor: pointer; /* 鼠标指针为手型 */
  font-size: 14px; /* 字体大小14px */
  transition: all 0.3s ease; /* 所有属性变化0.3秒缓动过渡 */
  min-width: 48px; /* 最小宽度48px */
  display: flex; /* 弹性布局 */
  align-items: center; /* 交叉轴居中 */
  justify-content: center; /* 主轴居中 */
}

/* 清空按钮样式 */
.clearinput-btn{
  padding: 12px 16px; /* 内边距上下12px，左右16px */
  background: #f53c8a; /* 背景颜色粉红色 */
  color: white; /* 文字颜色白色 */
  border: none; /* 无边框 */
  border-radius: 0 8px 8px 0; /* 右上和右下圆角8px，左上和左下0 */
  cursor: pointer; /* 鼠标指针为手型 */
  font-size: 14px; /* 字体大小14px */
  transition: all 0.3s ease; /* 所有属性变化0.3秒缓动过渡 */
  min-width: 48px; /* 最小宽度48px */
  display: flex; /* 弹性布局 */
  align-items: center; /* 交叉轴居中 */
  justify-content: center; /* 主轴居中 */
}

/* 粘贴按钮悬停状态 */
.paste-btn:hover {
  background: #d32f80; /* 背景颜色深粉红色 */
  transform: translateY(-1px); /* 向上移动1px */
}

/* 粘贴按钮按下状态 */
.paste-btn:active {
  transform: translateY(0); /* 回到原位置 */
}

/* 输入框悬停效果 */
.user-id-field:hover {
  border-color: #f53c8a; /* 边框颜色改为粉红色 */
}

/* 响应式设计 */
@media (max-width: 768px) { /* 当屏幕宽度小于等于768px时 */

  /* 用户ID字段容器响应式样式 */
  .user-id-field-container {
    flex-direction: column; /* 弹性方向垂直 */
    width: 100%; /* 宽度100% */
  }

  /* 用户ID输入框响应式样式 */
  .user-id-field {
    border-radius: 8px; /* 8px圆角 */
    margin-bottom: 0; /* 底部外边距0 */
    width: 100%; /* 宽度100% */
  }

  /* 粘贴按钮响应式样式 */
  .paste-btn {
    border-radius: 8px; /* 8px圆角 */
    width: 25%; /* 宽度25% */
    margin-top: 2px; /* 顶部外边距2px */
    margin-left: 8px; /* 左侧外边距8px */
  }

  /* 清空按钮响应式样式 */
  .clearinput-btn{
    border-radius: 8px; /* 8px圆角 */
    width: 18%; /* 宽度18% */
    margin-top: 2px; /* 顶部外边距2px */
    margin-left: 8px; /* 左侧外边距8px */
  }

  /* 会员页面响应式样式 */
  .vip-page {
    padding: 10px; /* 内边距10px */
  }

  /* 套餐容器响应式样式 */
  .packages {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); /* 网格列布局 */
    gap: 10px; /* 网格间距10px */
  }

  /* 套餐卡片响应式样式 */
  .package-card {
    padding: 10px; /* 内边距10px */
  }

  /* 固定支付栏响应式样式 */
  .fixed-pay-bar {
    padding: 10px; /* 内边距10px */
  }

  /* 支付信息响应式样式 */
  .pay-info {
    gap: 10px; /* 间距10px */
  }

  /* 价格文本响应式样式 */
  .price-text {
    font-size: 18px; /* 字体大小18px */
  }

  /* 支付按钮响应式样式 */
  .btn-pay {
    padding: 8px 16px; /* 内边距上下8px，左右16px */
    font-size: 14px; /* 字体大小14px */
  }
}

/* ========== 星空主题（深色） ========== */
.theme-starry {
  background-color: #0a0e27 !important;
}

.theme-starry .vip-page {
  background-color: #0a0e27 !important;
  color: #ccd6f6 !important;
}

.theme-starry body {
  background-color: #0a0e27 !important;
}

.theme-starry html {
  background-color: #0a0e27 !important;
}

.theme-starry .user-id-input label {
  color: #64ffda;
}

.theme-starry .user-id-field {
  background-color: #16213e !important;
  border-color: #2a2a4e !important;
  color: #ccd6f6 !important;
}

.theme-starry .user-id-field::placeholder {
  color: #8892b0;
}

.theme-starry .paste-btn,
.theme-starry .clearinput-btn {
  background-color: #16213e !important;
  border-color: #2a2a4e !important;
  color: #64ffda !important;
}

.theme-starry .paste-btn:hover,
.theme-starry .clearinput-btn:hover {
  background-color: #1a2745;
  border-color: #64ffda;
}

.theme-starry .help-btn {
  background-color: #16213e;
  border-color: #2a2a4e;
  color: #64ffda;
}

.theme-starry .help-btn:hover {
  background-color: #1a2745;
  border-color: #64ffda;
}

.theme-starry h3 {
  color: #ccd6f6;
}

.theme-starry .category-desc {
  color: #8892b0;
}

.theme-starry .package-card {
  background-color: #16213e !important;
  border-color: #2a2a4e !important;
  color: #ccd6f6 !important;
}

.theme-starry .package-card:hover {
  border-color: #64ffda;
  box-shadow: 0 4px 12px rgba(100, 255, 218, 0.2);
  background-color: #1a2745;
}

.theme-starry .package-card.active {
  border-color: #64ffda;
  box-shadow: 0 4px 12px rgba(100, 255, 218, 0.3);
  background-color: #1a2745;
}

.theme-starry .card-title {
  color: #64ffda !important;
}

.theme-starry .card-features {
  color: #8892b0;
}

.theme-starry .feature-item {
  color: #ccd6f6;
}

.theme-starry .price {
  color: #64ffda !important;
}

.theme-starry .page-footer {
  color: #8892b0;
}

.theme-starry .notice {
  color: #8892b0;
}

.theme-starry .wechat {
  color: #ccd6f6;
}

.theme-starry .wechat-id {
  color: #64ffda;
}

.theme-starry .copy-btn {
  background-color: #16213e;
  border-color: #2a2a4e;
  color: #64ffda;
}

.theme-starry .copy-btn:hover {
  background-color: #1a2745;
  border-color: #64ffda;
}

.theme-starry .fixed-pay-bar {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-top: 1px solid #2a2a4e;
}

.theme-starry .price-text {
  color: #64ffda;
}

.theme-starry .btn-pay {
  background: linear-gradient(135deg, #64ffda 0%, #00bcd4 100%);
  color: #0a0e27;
}

.theme-starry .btn-pay:hover {
  background: linear-gradient(135deg, #00bcd4 0%, #64ffda 100%);
  box-shadow: 0 4px 12px rgba(100, 255, 218, 0.4);
}

/* 星空主题 - Modal 弹窗样式 */
.theme-starry .ivu-modal-content {
  background-color: #1a1a2e !important;
  border: 1px solid #2a2a4e;
}

.theme-starry .ivu-modal-header {
  background-color: #16213e !important;
  border-bottom: 1px solid #2a2a4e;
}

.theme-starry .ivu-modal-header-inner {
  color: #ccd6f6 !important;
}

.theme-starry .ivu-modal-body {
  background-color: #1a1a2e !important;
  color: #ccd6f6 !important;
}

.theme-starry .ivu-modal-footer {
  background-color: #16213e !important;
  border-top: 1px solid #2a2a4e;
}

.theme-starry .ivu-alert {
  background-color: #16213e !important;
  border-color: #2a2a4e !important;
  color: #ccd6f6 !important;
}

.theme-starry .ivu-alert-info {
  background-color: #16213e !important;
  border-color: #64ffda !important;
}

.theme-starry .ivu-alert-warning {
  background-color: #1a2745 !important;
  border-color: #f59a23 !important;
}

.theme-starry p,
.theme-starry h3,
.theme-starry h4,
.theme-starry strong,
.theme-starry span {
  color: #ccd6f6 !important;
}

/* ========== 微信小程序风格弹窗 ========== */
/* 遮罩层 */
.wechat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

/* 弹窗主体 */
.wechat-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 340px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  animation: modal-slide-up 0.3s ease-out;
  position: relative;
}

/* 关闭按钮 */
.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
}

.modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* 标题区域 */
.modal-header {
  padding: 24px 20px 16px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

/* 内容区域 */
.modal-body {
  padding: 20px;
}

/* 步骤列表 */
.step-list {
  margin-bottom: 20px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 12px;
}

.step-number {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #07c160 0%, #06ad56 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.step-text {
  flex: 1;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
}

.step-text strong {
  color: #07c160;
  font-weight: 600;
}

/* 图片容器 */
.help-image-container {
  text-align: center;
  margin-top: 16px;
}

.help-image {
  width: 100%;
  max-width: 280px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.image-tip {
  font-size: 13px;
  color: #999;
  margin-top: 8px;
  text-align: center;
}

/* 底部按钮区域 */
.modal-footer {
  padding: 16px 20px 20px;
  border-top: 1px solid #f0f0f0;
}

.modal-btn {
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-btn.primary {
  background: linear-gradient(135deg, #07c160 0%, #06ad56 100%);
  color: white;
}

.modal-btn.primary:hover {
  background: linear-gradient(135deg, #06ad56 0%, #059948 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
}

.modal-btn.primary:active {
  transform: translateY(0);
}

/* 动画效果 */
@keyframes modal-slide-up {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

/* 星空主题下的弹窗样式 */
.theme-starry .wechat-modal {
  background: #1a1a2e;
  border: 1px solid #2a2a4e;
}

.theme-starry .modal-header {
  border-bottom-color: #2a2a4e;
}

.theme-starry .modal-title {
  color: #ccd6f6 !important;
}

.theme-starry .step-text {
  color: #ccd6f6 !important;
}

.theme-starry .step-text strong {
  color: #64ffda !important;
}

.theme-starry .image-tip {
  color: #8892b0;
}

.theme-starry .modal-footer {
  border-top-color: #2a2a4e;
}

.theme-starry .modal-close:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* ========== 微信小程序风格 Toast 提示 ========== */
.wechat-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(10px);
  padding: 16px 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 10000;
  min-width: 200px;
  max-width: 80vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: toast-scale-in 0.3s ease-out;
}

.toast-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-message {
  color: white;
  font-size: 15px;
  line-height: 1.5;
  word-break: break-word;
}

/* Toast 类型样式 */
.wechat-toast.success {
  background: rgba(7, 193, 96, 0.9);
}

.wechat-toast.error {
  background: rgba(250, 81, 81, 0.9);
}

.wechat-toast.warning {
  background: rgba(255, 153, 0, 0.9);
}

/* Toast 动画 */
@keyframes toast-scale-in {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter-from {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9);
}
</style>